// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterSubMenu_container__2SuNd","item":"FooterSubMenu_item__3Um5d","sending":"FooterSubMenu_sending__Sg735"};